import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-time-off-schedule-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfTimeOffScheduleIconProps extends SvgIconProps  {}

/**
 *
 * @param props - CcfTimeOffScheduleIcon
 * @example <CcfTimeOffScheduleIcon />
 * @returns
 */
export function CcfTimeOffScheduleIcon(props: CcfTimeOffScheduleIconProps) {
  return (
    <SvgIcon
      width="44"
      height="30"
      viewBox="0 0 44 30"
      fill="none"
      {...props}
    >
      <path
        d="M8.848 1.49707L9.357 2.79307"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.208 8.67925C22.937 2.90225 15.833 0.288242 9.34198 2.84124C2.85098 5.39424 -0.570002 12.1412 1.702 17.9222"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.74201 18.0342C1.44201 17.2782 2.81501 16.0341 4.80301 15.2501C6.79101 14.4661 8.643 14.4501 8.94 15.2041"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.05 11.6212C17.75 10.8652 15.477 11.0522 12.966 12.0392C10.455 13.0262 8.66603 14.4392 8.95903 15.1952C8.95903 15.1952 3.66603 5.07018 9.34703 2.83618"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.075 11.6143C18.075 11.6143 15.054 0.595237 9.37499 2.82924"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.054 11.6212C17.754 10.8652 19.127 9.6213 21.115 8.8373C23.103 8.0533 24.955 8.03728 25.252 8.79128"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.101 12.313L17.559 22.918"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.948 28.666C33.88 25.732 28.024 23.011 19.483 23.011C10.942 23.011 5.08301 25.731 4.01801 28.666"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.506 15.5172C37.946 15.5172 39.924 13.5391 39.924 11.0992C39.924 8.65916 37.946 6.68115 35.506 6.68115C33.066 6.68115 31.088 8.65916 31.088 11.0992C31.088 13.5391 33.066 15.5172 35.506 15.5172Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.506 5.45816V3.44116"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.441 5.80125L38.133 3.90625"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.141 6.78614L40.441 5.24414"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.4 8.29524L42.15 7.29224"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.065 10.1442L43.053 9.80322"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.055 12.1091L43.04 12.4701"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.371 13.9512L42.111 14.9712"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.097 15.4482L40.381 17.0032"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.387 16.4163L38.06 18.3183"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.449 16.7393L35.429 18.7563"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.517 16.3772L32.806 18.2652"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.828 15.3743L30.512 16.9033"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.583 13.8533L28.823 14.8383"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.937 11.9971L27.946 12.3181"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.967 10.0321L27.986 9.65112"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.669 8.19718L28.939 7.15918"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.959 6.71326L30.69 5.14526"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.678 5.76225L33.024 3.85425"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default CcfTimeOffScheduleIcon;
